<script setup lang="ts">
import { type Component, type PropType, onMounted, ref } from "vue";
import { type IconKey, getComponentForIcon } from "./async-icons";

// eslint-disable-next-line no-undef
const props = defineProps({
    value: String as PropType<IconKey>,
    color: {
        type: String,
        default: "black",
    },
});

const componentData =
    props.value == null ? null : getComponentForIcon(props.value);
const compDefPromise = componentData != null ? componentData() : null;
const compDef = ref<Component | null>(null);

onMounted(async () => {
    if (compDefPromise != null) {
        // @ts-ignore
        compDef.value = await compDefPromise;
    }
});
</script>

<template>
    <component v-if="compDef != null" :is="compDef" :color="color"></component>
    <span v-else :data-icon="value"></span>
</template>
